import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material, Object3D } from '@wonderlandengine/api';


/**
 * Centre Console Description:
 */
export class CentreConsoleDescription extends Component {
	static TypeName = 'centre-console-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	consoleId: string = '';

	@property.object()
	consoleObject: Object3D | null = null;

	@property.material()
	consoleMaterial: Material | null = null;

	@property.material()
	railMaterial: Material | null = null;
}